export default(velocity, targetElementId, offsetValue) => {
    const scrollToTargetAdjusted = (targetElementId, offsetValue) => {
        const element = document.getElementById(targetElementId);

        if (!element) {
            return;
        }

        velocity(element, 'scroll',  {
            duration: 1000,
            easing: [.075, .82, .165, 1],
            offset: offsetValue,
        });
    };

    scrollToTargetAdjusted(targetElementId, offsetValue);
};